import script from "./AppInput.vue?vue&type=script&setup=true&lang=js"
export * from "./AppInput.vue?vue&type=script&setup=true&lang=js"

import "./AppInput.vue?vue&type=style&index=0&id=b5a6f4b0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5a6f4b0"]])

export default __exports__